import { render, staticRenderFns } from "./NoPrioritiesBlock.vue?vue&type=template&id=b0914794&scoped=true&"
import script from "./NoPrioritiesBlock.vue?vue&type=script&lang=js&"
export * from "./NoPrioritiesBlock.vue?vue&type=script&lang=js&"
import style0 from "./NoPrioritiesBlock.vue?vue&type=style&index=0&id=b0914794&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0914794",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
